export default __webpack_public_path__ + "static/media/Will.67e9a2ed.pdf";